import * as React from "react";
import { forwardRef } from "react";
const SvgIconClose = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={24} height={24} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd"><path d="M0 0h24v24H0z" /><g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}><path d="M15.656 8 8 15.656M15.656 15.656 8 8" /></g></g></svg>;
const ForwardRef = forwardRef(SvgIconClose);
export { ForwardRef as ReactComponent };